import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from 'react-router-dom'
import { getSkillAction, getSkillAuthorsAction} from "../store/actions";
import SkillInfoDrawer from "../components/SkillInfoDrawer";
import SquareButton from "../../../../ui/SquareButton";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Button from "../../../../ui/Button";
import SkillViewTabs from "./components/SkillViewTabs";
import Tabs from "../../../../ui/Tabs";
import Progress from "../../../../ui/Progress";
import Box from "../../../../ui/Box";
import TopBar from "./components/TopBar";
import {useMediaQuery} from 'react-responsive';

import SkillEditQualification from './components/SkillViewTabs/components/SkillEditQualification';
import SkillEditPassport from './components/SkillViewTabs/components/SkillEditPassport';
import SkillEditWorkplace from './components/SkillViewTabs/components/SkillEditWorkplace';
import SkillEditStaff from './components/SkillViewTabs/components/SkillViewStaff';
import SkillViewInfrastructure from './components/SkillViewTabs/components/SkillViewInfrastructure';
import SkillViewDesc from './components/SkillViewTabs/components/SkillViewDesc';
import SkillViewGrading from './components/SkillViewTabs/components/SkillViewGrading';
import SkillViewStaff from './components/SkillViewTabs/components/SkillViewStaff';
import SkillViewWorkplace from './components/SkillViewTabs/components/SkillEditWorkplace';

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Справочник компетенций и ФГОС",
    link: "/work/app/manage/resources/competfgos"
  },
  {
    label: "Справочник компетенций",
    link: "/work/app/dict/skills/skill"
  }
];

const tabitems = [
  {number: 0, caption: "Паспорт"},
  {number: 1, caption: "Описание"},
  {number: 2, caption: "Квалификационные требования"},
  {number: 3, caption: "Инфраструктурный лист"},
  {number: 4, caption: "Требования к организации рабочего места и технике безопасности"},
  {number: 5, caption: "Требования к квалификации педагогического состава"},
  {number: 6, caption: "Оценивание"}
];

const useStyles = makeStyles({
  skillRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  }
});


const SkillView = (props) => {
  const skillId = props.match.params.id;
  const {skill, authors, getSkill, getAuthors} = props;
  const classes = useStyles();

  const isMedium = useMediaQuery({maxWidth: 1024});
  const isLarge = useMediaQuery({minWidth: 1024});
  const isSmall = useMediaQuery({maxWidth: 774});

  useEffect(() => {
    getSkill(skillId);
    getAuthors(skillId);
  }, []);

  const goBack = () => {
      props.history.goBack();
  }

  return (
    <div>
      <Breadcrumbs items={items} />
      {(skill && skill.info) ? (
        <div className={classes.skillRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reload={() => getSkill(skillId)}
                returnBack={goBack}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                {skill.data && <SkillEditPassport skillAuthors={authors} skill={skill} skillId={skillId} />}
              </Box>
              <Box>
                {skill.data && <SkillViewDesc desc={skill.data.description} />}
              </Box>
              <Box>
                {skill.data && <SkillEditQualification id={skill.info.id} />}
              </Box>
              <Box>
                {skill.data && <SkillViewInfrastructure id={skill.info.id} />}
              </Box>
              <Box>
                {skill.data &&  <SkillViewWorkplace safety={skill.data.safety}
                                  safetyFirst={skill.data.safetyFirst}
                                  safety />
                                }
              </Box>
              <Box>
                {skill.data &&
                  <SkillViewStaff
                      teacherLevel={skill.data.teacherLevel}
                      teacherStage={skill.data.teacherStage}
                      teacherProf={skill.data.teacherProf}
                      teacherExtra={skill.data.teacherExtra}
                  />
                }
              </Box>
              <Box>
                {skill.data && <SkillViewGrading id={skill.info.id} />}
              </Box>
            </Tabs>
            </div>

            {isLarge &&
            <SkillInfoDrawer skillId={skillId} open hideLink/>}
            </div>
          ) : (
            <Progress/>
          )}
          </div>
        );
      };

const mapStateToProps = state => ({
    skill: state.skill.skill,
    authors: state.skill.skillAuthors
});

const mapDispatchToProps = dispatch => ({
    getSkill: (skillId) => dispatch(getSkillAction(skillId)),
    getAuthors: (skillId) => dispatch(getSkillAuthorsAction(skillId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SkillView));
